<template>
    <el-dialog
      :visible.sync="isOpen"
      width="900px"
      :show-close="true"
      class="egl-dialog-elm channel-dialog"
      :title="$locale('global.item') + actionText"
      :close-on-click-modal="false"
    >
      <el-form :disabled="this.action == 'detail'" :model="form" ref="detailForm" :rules="formRules" label-position="top">
        <div class="form-module">
          <div class="form-module-tit">{{ $locale("global.basicInfo") }}</div>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$locale('shop.barcode')" class="long-item" prop="barCode">
                <el-input
                  v-model="form.barCode"
                  :placeholder="$locale('shop.plsEnterBarcode')"
                  maxlength="255"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$locale('shop.productCode')" class="long-item" prop="productCode">
                <el-input
                  v-model="form.productCode"
                  :placeholder="$locale('shop.productCode.p')"
                  maxlength="255"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$locale('global.name')" class="long-item" prop="name">
                <el-input
                  v-model="form.name"
                  :placeholder="$locale('form.plsEnterYourName')"
                  maxlength="255"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$locale('global.price_taxIncluded')" class="long-item" prop="price">
                <el-input
                  v-model.number="form.price"
                  :placeholder="$locale('form.plsEnterPrice')"
                  @keyup.enter.native="getNotTaxPrice"
                  @blur="getNotTaxPrice"
                  maxlength="20"
                >
                  <template slot="prepend">¥</template>
                </el-input>
              </el-form-item>
              <el-form-item :label="$locale('shop.taxDisplay')" prop="taxRate">
                <TaxSelect v-model="form.taxRate" :isSalesOption="false" @change="getNotTaxPrice"/>
                <!-- <el-select v-model="form.taxRate" @change="getNotTaxPrice">
                  <el-option
                    v-for="item in taxIndication"
                    :label="taxRatesMap[item]"
                    :value="item"
                    :key="item"
                  ></el-option>
                </el-select> -->
              </el-form-item>
              <el-form-item :label="$locale('shop.amount_excludingTax')" class="not-tax-price" prop="notTaxPrice">
                <el-input v-model="form.notTaxPrice" disabled maxlength="20">
                  <template slot="prepend">¥</template>
                </el-input>
              </el-form-item>
              <el-form-item :label="$locale('shop.purchasePrice_taxIncluded')" prop="productCost">
                <el-input v-model="form.productCost" maxlength="20" @input.native="getNotTaxPrice" @change="value => priceFormatter(value, 'productCost')">
                  <template slot="prepend">¥</template>
                </el-input>
              </el-form-item>
              <el-form-item :label="$locale('shop.purchasePriceUnit_taxIncluded')" class="not-tax-price" prop="priceWithoutTax">
                <el-input v-model="form.priceWithoutTax" maxlength="20" @input.native="getTaxedPrice"
                  :disabled="true">
                  <template slot="prepend">¥</template>
                </el-input>
              </el-form-item>
              <el-form-item
                :label="$locale('shop.consumptionTax_purchaseCost')"
                class="long-item"
                prop="taxRateCost"
              >
                <TaxSelect v-model="form.taxRateCost" :isSaleOption="true" @change="getNotTaxPrice"/>
                <!-- <el-select v-model="form.taxRateCost" @change="getNotTaxPrice">
                  <el-option
                    v-for="item in saleTaxOption"
                    :label="item.label"
                    :value="item.value"
                    :key="item.value"
                  ></el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="2">
              <el-form-item style="width: 100%;" :label="$locale('global.image') + $locale('shop.upload.tips')" prop="imageUrl" class="upload">
                <UploadContainer
                  :type="'B'"
                  :imageList="[form.imageUrl]"
                  @onSuccess="({response}) => uploadSuccess(response)"
                  @onDelete="deleteImg"
                ></UploadContainer>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="form-module">
          <div class="form-module-tit">{{ $locale("shop.inventorySetting") }}</div>
          <el-row :gutter="20" class="inventory-setting">
            <el-col :span="8">
              <el-form-item :label="$locale('shop.inventoryControl')" prop="useStock">
                <BoolSelect v-model="form.useStock" :optionObj="boolSelectObj"></BoolSelect>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item :label="$locale('shop.autoSoldOut')" prop="useAutoSoldOut">
                <BoolSelect
                  v-model="form.useAutoSoldOut"
                  :optionObj="boolSelectObj"
                  :disabled="!form.useStock"
                ></BoolSelect>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item :label="$locale('shop.stockLocation')" prop="stockPlace">
                <el-input
                  v-model="form.stockPlace"
                  :placeholder="$locale('shop.plsEnterStockLocation')"
                  maxlength="255"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item :label="$locale('global.unit')" prop="unit">
                <el-input
                  v-model="form.unit"
                  :placeholder="$locale('form.plsEnterUnit')"
                  maxlength="255"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="form-module">
          <div class="form-module-tit">{{ $locale("shop.salesRelatedInfo") }}</div>
          <div class="clearfix">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item :label="$locale('shop.productType')" prop="productType" class="makeFull">
                  <el-select v-model="form.productType" >
                    <el-option
                      v-for="item in productTypeOption"
                      :label="saleFormMap[item]"
                      :value="item"
                      :key="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$locale('global.works')" prop="filmId" class="makeFull">
                  <el-select v-model="form.filmId" filterable clearable>
                    <el-option
                      v-for="item in movieList"
                      :label="item.name"
                      :value="item.id"
                      :key="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- for some reason this options cannot be selected -->
            <!-- <el-form-item :label="$locale('shop.productType')" prop="productType">
              <el-select v-model="form.productType" @click="handleProductType">
                <el-option
                  v-for="item in productTypeOption"
                  :label="saleFormMap[item]"
                  :value="item"
                  :key="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$locale('global.works')" prop="filmId">
              <el-select v-model="form.filmId">
                <el-option
                  v-for="item in movieList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item :label="$locale('shop.supplier')" prop="supplier" class="makeFull">
                  <!-- <el-select v-model="form.clientId" filterable clearable>
                    <el-option
                      v-for="item in clientList"
                      :label="item.name"
                      :value="item.id"
                      :key="item.id"
                    ></el-option>
                  </el-select> -->
                  <!-- <template v-if="isOpen">
                    <remote-select
                      type="client"
                      :isMultiple="false"
                      v-model="form.clientId"
                      :formValue.sync="form.clientId"
                      :actionType="action"
                    ></remote-select>
                  </template> -->
                  <RemoteSelectV2
                    ref="selectV2Client"
                    type="client"
                    :list="comClientList"
                    v-model="form.clientId"
                    :isMultiple="false"
                    :formValue.sync="form.clientId"
                    :fields="['id', 'name']"
                    @setList="arr => comClientList = arr"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$locale('shop.couponType')" prop="commercialTypeEnum" class="makeFull">
                  <el-select v-model="form.commercialTypeEnum" @change="handleMoviTicketChange">
                    <el-option
                      v-for="item in commercialTypeEnumOption"
                      :label="item.label"
                      :value="item.value"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$locale('shop.ticketTaxFee')" prop="movieTicketingTaxFee" class="makeFull">
                  <el-input v-model.number="form.movieTicketingTaxFee" @input.native="handleMoviFees"
                    :disabled=" form.commercialTypeEnum === 'default' || form.commercialTypeEnum === 'preSales'" >
                    <template slot="prepend">¥</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="form-module">
          <div class="form-module-tit">{{ $locale("shop.couponSetting") }}</div>
          <div class="clearfix">
            <el-form-item :label="$locale('shop.unavailableCoupon')" prop="unavailableCoupons">
              <!-- <el-select
                v-model="form.unavailableCoupons"
                :multiple="true"
                clearable

              >
                <el-option
                        v-for="item in couponTypeList"
                        :label="item.name"
                        :value="item.id"
                        :key="item.id"
                ></el-option>
              </el-select> -->
              <!-- <template v-if="isOpen">
                <remote-select
                v-model="form.unavailableCoupons"
                :formValue.sync="form.unavailableCoupons"
                :actionType="action"
                @selectAll="arr => form.unavailableCoupons = arr"
              ></remote-select>
              </template> -->
              <RemoteSelectV2
                ref="selectV2Coupon"
                type="coupon"
                :list="comCouponList"
                v-model="form.unavailableCoupons"
                :formValue.sync="form.unavailableCoupons"
                :fields="['id', 'name']"
                @setList="arr => comCouponList = arr"
                @selectAll="arr => form.unavailableCoupons = arr"
                :isSelectAllFunc="true"
                :isCollapse="true"
              />
            </el-form-item>
          </div>
        </div>

        <div class="form-module">
          <div class="form-module-tit">{{ $locale("shop.optionSetting") }}</div>
          <div class="clearfix dynamic-table">
            <div class="table-box">
              <el-table :data="form.options" class="egl-table" border>
                <el-table-column :label="$locale('global.productCode')" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.productCode"
                      :placeholder="$locale('form.plsEnterProductCode')"
                      maxlength="255"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column :label="$locale('global.name')" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.name"
                      :placeholder="$locale('form.plsEnterYourName')"
                      maxlength="255"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column :label="$locale('shop.stockLocation')" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.stockPlace"
                      :placeholder="$locale('shop.plsEnterStockLocation')"
                      maxlength="255"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column :label="$locale('shop.barcode')" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.barCode"
                      :placeholder="$locale('shop.plsEnterBarcode')"
                      maxlength="255"
                    ></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="table-handle-btn" v-if="this.action != 'detail'">
              <div class="btn-item" v-for="(obj, i) in form.options" :key="i">
                <i
                  class="el-icon-remove-outline"
                  v-if="form.options.length > 1"
                  @click="removeTableRow(i)"
                ></i>
                <i
                  class="el-icon-circle-plus-outline"
                  v-if="i == form.options.length - 1"
                  @click="addTableRow"
                ></i>
              </div>
            </div>
          </div>
        </div>

        <div class="form-module">
          <div class="form-module-tit">{{ $locale("global.dispRelatedSettings") }}</div>
          <div class="clearfix">
            <el-form-item :label="$locale('global.hiddenSetting')" class="undisplay">
              <div class="undisplay-btn clearfix">
                <el-button
                  v-for="btn in unDisplayBtn"
                  :key="btn.text"
                  :class="
                    form[btn.keyName] == true
                      ? 'egl-btn-white-gray-border'
                      : 'egl-btn-white'
                  "
                  @click="unDisplay_fn(btn.keyName)"
                  >{{ btn.text }}</el-button
                >
              </div>
            </el-form-item>
          </div>
          <div class="clearfix">
            <el-form-item :label="$locale('global.btnBackgroundColor') + '（' + $locale('global.POS') + '）'" prop="bgColor">
              <ColorPicker v-model="form.bgColor" @change="clearFormValidate('bgColor')" />
            </el-form-item>
            <el-form-item :label="$locale('global.btnTextColor') + '（' + $locale('global.POS') + '）'" prop="fontColor">
              <ColorPicker v-model="form.fontColor" @change="clearFormValidate('fontColor')" />
            </el-form-item>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item :label="$locale('form.displayPOS')" prop="groupId" class="makeFull">
                  <el-select
                          :placeholder="$locale('shop.plsSelectDepartment')"
                          v-model="form.groupId"
                  >
                    <el-option
                            v-for="item in departmentOption"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$locale('global.displayOrder') + '（' + $locale('global.POS') + '）'" prop="sort" class="makeFull">
                  <el-input
                    v-model.number="form.sort"
                    :placeholder="$locale('form.plsEnterNumDispOrder_POS')"
                    maxlength="5"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item :label="$locale('global.status')" prop="publish" class="makeFull">
                  <el-select v-model="form.publish">
                    <el-option
                      v-for="item in publishOption"
                      :label="item.text"
                      :value="item.type"
                      :key="item.type"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$locale('shop.kiosk.groups')" class="makeFull">
                  <el-select v-model="form.cinemaDailySelective" >
                    <el-option v-for="item in cinemaDailys"
                      :label="item.name"
                      :value="item.id"
                      :key="item.id"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$locale('bookKeeping.journal.dept')+' ('+$locale('setting.pay.accgroup')+')'" class="makeFull">
                  <el-select v-model="form.journalType">
                    <el-option v-for="item in tradeGroupList"
                      :label="item.name"
                      :key="item.id"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <ApproveField v-model="form.approveDate" :formData="form" fieldName="approveDate" />
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="this.action != 'detail'">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-button class="egl-btn-white" @click="close_fn">{{$locale("global.cancel")}}</el-button>
            <el-button class="egl-btn-yellow" @click="save_fn">{{$locale("global.confirm")}}</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
</template>
<style scoped>
.makeFull {
  width: 100% !important
}
</style>
<script>
import TaxSelect from "@/components/common/TaxSelect";
import ApproveField from "@/components/common/ApproveField";
// import ShopProductPrice from "@/components/common/ShopProductPrice";
import { positiveNumValidator, hexColorValidator } from "@/utils/formFieldValidator";
import { taxOff, taxOffDec, taxAddDec } from "@/utils/math.js";
import { kioskOpts, kioskMaps, taxRatesMap, taxRateOpts, saleForm, saleFormMap } from "@/utils/common.js"
import { getListService } from "@/helpers/service/api/tradeGroup"
import ColorPicker from "@/components/common/ColorPicker";
import UploadContainer from "@/components/common/UploadContainer";
import BoolSelect from "@/components/common/BoolSelect";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import { getClientListService } from "@/helpers/service/api/common";
import { getCouponTypeListForSelect } from "@/helpers/service/api/coupon";
import { getCinemaDailyListService } from "@/helpers/service/api/theaterDailyShow.js";
import { decimal2 } from "@/utils/utils";
import { getCinemaDailyIdForName } from "@/utils/common";

export default {
  name: "CommercialDialog",
  data() {
    return {
      form: this.createForm(),
      visible: false,
      actionText: "",
      roundSetting : window.localStorage.getItem('round'),
      cinemaDailys: [],
      kioskMaps : kioskMaps,
      kioskOpts : kioskOpts,
      productTypeOption: saleForm,
      saleFormMap : saleFormMap,
      tradeGroupList: [],
      unDisplayBtn: [
        {
          text: this.$locale("global.POS"),
          keyName: "displayPos"
        },
        {
          text: this.$locale("global.selfCashier"),
          keyName: "displaySelfCashier"
        }
      ],
      publishOption: [],
      uploadUrl: "/api/system/uploadFile",
      file: [],
      tokenObj: {},
      formRules: {
        name: [ {
          required: true,
          message: this.$locale("form.plsEnterYourName"),
          trigger: "blur",
        } ],
        price: [
          {
            required: true,
            message: this.$locale("form.plsEnterPrice"),
            trigger: "blur",
          },
          {
            type: "number",
            message: this.$locale("form.mustFillInNum"),
            trigger: "blur",
          },
          {
            validator: positiveNumValidator,
            trigger: "blur",
          },
        ],
        productType: [ {
          required: true,
          message: this.$locale("shop.plsSelectProductType"),
          tirgger: "change",
        } ],
        productCost: [
          {
            validator: positiveNumValidator,
            trigger: "blur",
          }
        ],
        // priceWithoutTax: [
        //   {
        //     validator: positiveNumValidator,
        //     trigger: "blur",
        //   }
        // ],
        sort: [
          {
            validator: positiveNumValidator,
            trigger: "blur",
          }
        ],
        commercialTypeEnum: [
          {
            required: true,
            message: "",
            trigger: "blur",
          }
        ],
        filmId: [
          {
            required: false,
            message: this.$locale("shop.plsSelectWorks"),
            trigger: "change",
          }
        ],
        movieTicketingTaxFee: [
          {
            validator: this.validatePrice,
            trigger: "blur"
          }
        ],
        useStock: [ {
          required: true,
          message: this.$locale("shop.plsSelectUseStock"),
        } ],
        // movieTicketingTaxFee: [
        //   {
        //     type: "number",
        //     message: this.$locale("form.mustFillInNum"),
        //     trigger: "blur",
        //   },
        //   {
        //     validator: positiveNumValidator,
        //     trigger: "blur",
        //   }
        // ],
      },
      commercialTypeEnumOption: [
        {
          value: "default",
          label: this.$locale("shop.couponType.option1"),
        },
        {
          value: "movieTickting",
          label: this.$locale("shop.couponType.option2"),
        },
        {
          value: "movieTicktingOther",
          label: this.$locale("shop.couponType.option3"),
        },
        {
          value: "preSales",
          label: this.$locale("shop.couponType.option4"),
        }
      ],
      boolSelectObj: [
        {
          label: this.$locale("shop.option.utilize"),
          value: true
        },
        {
          label: this.$locale("shop.option.notUsed"),
          value: false
        }
      ],
      comClientList: [],
      comCouponList: [],
    };
  },
  methods: {
    handleMoviFees() {
      const { movieTicketingTaxFee, price, notTaxPrice, taxRateCost } = this.form

      if( price == '') {
        this.form.movieTicketingTaxFee = ''
        return
      }
      if( movieTicketingTaxFee > price ) {
        this.form.movieTicketingTaxFee = price
      }
      let ctaxrate = 0
      if(taxRateCost == "percentTen") ctaxrate = 0.1
      else if (taxRateCost == "percenteight") ctaxrate = 0.08
      else ctaxrate = 0

      let taxoffcost = notTaxPrice - movieTicketingTaxFee
      if(taxoffcost < 0) {
        taxoffcost = 0
      }
      let cost = taxAdd(taxoffcost, ctaxrate, this.roundSetting)
      // this.form.productCost = isNaN(cost) ? 0 : cost
      this.form.priceWithoutTax = taxoffcost
    },
    handleMoviTicketChange() {
      const { commercialTypeEnum } = this.form
      if( commercialTypeEnum == 'default') {
        this.form = {
          ...this.form,
         movieTicketingTaxFee : '',
        }
      }
      else if (commercialTypeEnum == 'preSales') {
        this.form = {
          ...this.form,
          movieTicketingTaxFee: 0
        };
      }
      else {
        this.form = {
          ...this.form,
          productCost: 0,
          priceWithoutTax: 0,
        }
      }

      if (commercialTypeEnum == "default" || commercialTypeEnum == "preSales") {
        this.formRules.filmId[0].required = false;
      } else {
        this.formRules.filmId[0].required = true;
      }
    },
    createForm() {
      return {
        barCode: "",
        productCode: "",
        name: "",
        price: 0,
        // taxRate: 0.08,
        taxRate: 0.1,
        notTaxPrice: 0,
        productCost: 0,
        taxRateCost: "percentTen",
        imageUrl: "",

        stockPlace: "",

        inventory: 0,
        groupId: '',
        unit: "",
        salesGroup: { id: null, name: null },
        productType: "SALES_ITEM",
        clientId: "",
        filmId: "",
        unavailableCoupons: [],

        options: [],

        displayPos: true,
        displaySelfCashier: true,
        bgColor: "#FFFFFF",
        fontColor: "#000000",
        sort: "",
        publish: "RELEASE",
        approveDate: this.$moment().startOf("day").valueOf(),
        useStock: true,
        useAutoSoldOut: false,

        commercialTypeEnum: "default",
        movieTicketingTaxFee: '',
        cinemaDailySelective : '',
      };
    },
    close_fn() {
      this.$emit("closeFn");
    },
    save_fn() {
      const that = this;
      // let obj = RuleTest(that.rule, that.form);
      let data = { ...this.form };
      let options = [];

      this.$refs.detailForm.validate(valid => {
        if (valid) {
          // if (!obj.success) {
          //   that.$alert(obj.message, {
          //     showClose: false
          //   });

          //   return;
          // }

          // data = { ...obj.data };

          // for (let i = 0; i < that.salesGroupData.length; i++) {
          //   if (that.salesGroupData[i].id == data.salesGroup) {
          //     data.salesGroup = {
          //       id: that.salesGroupData[i].id,
          //       name: that.salesGroupData[i].name,
          //     };

          //     break;
          //   }
          // }

          const targetGroup = that.salesGroupData.find(group => group.id === data.salesGroup.id) || {};
          data.salesGroup = {
            id: targetGroup.id,
            name: targetGroup.name,
          };

          this.form.options.map(optionObj => {
            if (optionObj.name != "") {
              let item = JSON.parse(JSON.stringify(optionObj));

              // item.ingredientIds = [];
              // let ingredientIdsLength = item.ingredientIds.length;

              // if (optionObj.ingredientIds[ingredientIdsLength - 1].ingredientId == "") {
              //   item.ingredientIds.splice(ingredientIdsLength - 1, 1);
              // }

              options.push(item);
            }
          });

          data.options = options;

          if (data.filmId === null) {
            data.filmId = "";
          }

          that.$emit("returnMsg", data);
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);

          return false;
        }
      });
    },
    getNotTaxPrice() {
      let { price, productCost, taxRate, taxRateCost, commercialTypeEnum } = this.form;
      let notTaxPrice = taxOff(price, taxRate, this.roundSetting)
      let ctaxrate = 0
      if(taxRateCost == "percentTen") ctaxrate = 0.1
      else if (taxRateCost == "percenteight") ctaxrate = 0.08
      else ctaxrate = 0

      let noTaxCost = taxOffDec(productCost, ctaxrate, this.roundSetting)
      this.form = { ...this.form,
        notTaxPrice: isNaN(notTaxPrice) ? 0 : notTaxPrice,
        priceWithoutTax : isNaN(noTaxCost) ? 0 : noTaxCost,
      };

      if(commercialTypeEnum != 'default') {
        this.handleMoviFees()
        return
      }
    },
    getTaxedPrice() {
      let {  taxRateCost, priceWithoutTax } = this.form;
      let ctaxrate = 0
      if(taxRateCost == "percentTen") ctaxrate = 0.1
      else if (taxRateCost == "percenteight") ctaxrate = 0.08
      else ctaxrate = 0

      let taxedCost = taxAddDec(priceWithoutTax, ctaxrate, this.roundSetting)
      this.form = { ...this.form,
        productCost: isNaN(taxedCost) ? 0 : taxedCost,
      };
    },
    uploadSuccess(res) {
      if (res.success) {
        this.form = { ...this.form, imageUrl: res.data };
      }
      this.file = [];
    },
    deleteImg() {
      this.form = { ...this.form, imageUrl: "" };
    },
    unDisplay_fn(keyName) {
      let formObj = { ...this.form };
      formObj[keyName] = !formObj[keyName];

      this.form = { ...formObj };
    },
    addTableRow() {
      let formObj = { ...this.form };

      if (formObj.options[formObj.options.length - 1].name != "") {
        formObj.options.push({
          barCode: "",
          inventory: 0,
          name: "",
          productCode: "",
          stockPlace: ""
        });

        this.form = { ...formObj };
      }
    },
    removeTableRow(index) {
      let formObj = { ...this.form };
      formObj.options.splice(index, 1);

      this.form = { ...formObj };
    },
    clearFormValidate(fieldName) {
      if (fieldName) {
        this.$refs.detailForm.clearValidate(fieldName);
      } else {
        this.$refs.detailForm.clearValidate();
      }
    },
    validatePrice(rule,value, callback) {
      if(this.form.commercialTypeEnum !== "default" && value === "") {
        callback(new Error(this.$locale("shop.plsInputticketTaxFee")));
      } else {
        callback();
      }
    },
    priceFormatter(value, type) {
      this.form[type] = Number(decimal2(value))
    },
  },
  mounted() {
    getCinemaDailyListService({ cinemaId: window.localStorage.getItem("cinemaId") }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.cinemaDailys = res.data.data;
      }
    });
    // let actionText = "";
    // let dictionary = window.localStorage.getItem("dictionary") || "";
    // console.log("mounted", JSON.parse(dictionary))
    // let productTypeOption = [];
    const statusArr = [
      {
        type: "RELEASE",
        text: this.$locale("global.sale"),
      },
      {
        type: "RESERVE",
        text: this.$locale("global.stopSelling"),
      }
    ];

    // if (dictionary != "") {
    //   dictionary = JSON.parse(dictionary);

    //   Object.keys(dictionary.ticketing.ProductType).map(keyName => {
    //     if (keyName == "SALES_ITEM") {
    //       productTypeOption.push({
    //         label: this.$locale("global.purchase"),
    //         val: "SALES_ITEM"
    //       });
    //     } else if (keyName == "CONSIGNMENT") {
    //       productTypeOption.push({
    //         label: this.$locale("global.entrust"),
    //         val: "CONSIGNMENT"
    //       });
    //     } else {
    //       productTypeOption.push({
    //         label: keyName,
    //         val: keyName
    //       });
    //     }
    //   });
    // }

    this.visible = this.actionVisible;
    this.tokenObj = {
      Authorization: window.localStorage.getItem("token")
    };
    // this.productTypeOption = productTypeOption;
    this.publishOption = statusArr;
  },
  props: {
    action: {
      type: String,
      default: "create"
    },
    actionVisible: {
      type: Boolean,
      default: false
    },
    departmentOption: {
      type: Array,
      default: () => [],
    },
    salesGroupData: {
      type: Array,
      default: () => [],
    },
    couponTypeList: {
      type: Array,
      default: () => [],
    },
    movieList: {
      type: Array,
      default: () => [],
    },
    detailObj: {
      type: Object,
      default: () => [],
    },
    clientList: {
      type: Array,
      default: () => [],
    },
    brandSetting: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isOpen: {
      get() {
        return this.visible;
      },
      set() {
        this.close_fn();
      },
    }
  },
  watch: {
    "form.useStock"(newV) {
      // 不使用库存管理的商品不适用自动售罄
      if (!newV) {
        this.form.useAutoSoldOut = false;
      }
    },
    actionVisible(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.tradeGroupList.length === 0) {
            getListService({
              brandId: window.localStorage.getItem('brandId')
            }).then(res => {
              this.tradeGroupList = res.data
            }).catch( err => {
              console.log(err)
            })
          }
          this.$refs["selectV2Client"].page = 1;
          this.$refs["selectV2Coupon"].page = 1;
          if (this.action !== "create") {
            if (this.form.clientId) {
              getClientListService({
                ids: [ this.form.clientId ],
                page: 0,
                pageSize: 9999,
                field: ["id", "name"]
              }).then(res => {
                this.comClientList = this.$_.uniqBy(res.data.data.concat(this.clientList), "id");
              });
            }
            if (this.form.unavailableCoupons && this.form.unavailableCoupons.length > 0) {
              getCouponTypeListForSelect({
                cinemaId: window.localStorage.getItem("cinemaId"),
                ids: this.form.unavailableCoupons,
                page: 0,
                pageSize: 9999,
                field: ["id", "name"]
              }).then(res => {
                this.comCouponList = this.$_.uniqBy(res.data.data.concat(this.couponTypeList), "id");
              });
            }
          }
          this.comClientList = this.clientList;
          this.comCouponList = this.couponTypeList;
        });
      }
      let formObj = this.createForm();
      formObj.cinemaDailySelective = getCinemaDailyIdForName(this.cinemaDailys);
      let actionText = "";

      if (this.detailObj.id) {
        formObj = {
          ...formObj,
          ...this.detailObj,
          salesGroup: this.detailObj.salesGroup ? this.detailObj.salesGroup : formObj.salesGroup,
        };
      }

      if (this.action == "create") {
        actionText = this.$locale("global.create");
      } else if (this.action == "detail") {
        actionText = this.$locale("global.detail");
      } else {
        actionText = this.$locale("global.edit");
      }

      this.actionText = actionText;
      if (this.$refs.detailForm) {
        this.$refs.detailForm.resetFields();
      }
      this.visible = this.actionVisible;
      this.tokenObj = {
        Authorization: window.localStorage.getItem("token")
      };

      if (!formObj.options || formObj.options.length == 0) {
        formObj.options = [{
          barCode: "",
          inventory: 0,
          name: "",
          productCode: "",
          stockPlace: ""
        }]
      }

      this.form = { ...formObj };

      this.getNotTaxPrice();
    },
  },
  components: {
    TaxSelect,
    ApproveField,
    // ShopProductPrice,
    ColorPicker,
    UploadContainer,
    BoolSelect,
    RemoteSelectV2,
  },
};
</script>
